import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/stores/app-gallery.svg")